import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { getEmailData, postEmailData, postCommentData } from '../_model/communication';

import * as constants from '../_model/string_literal';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {
  emailSummary: getEmailData[] = [];

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    const parsedToken = token ? JSON.parse(token) : null;
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': parsedToken?.token ? `Bearer ${parsedToken.token}` : ''
    });
  }

  get httpOptionsAuth() {
    return { headers: this.getAuthHeaders() };
  }

  constructor(
    private http: HttpClient,
  ) { }

  getEmailSummary() {
    return this.http.get(constants.IAPI_ENDPOINT + '/communication/email', this.httpOptionsAuth);
  }

  getEmailById(id: string) {
    return this.http.get(constants.IAPI_ENDPOINT + `/communication/email/content/${id}`, this.httpOptionsAuth);
  }

  getEmailThreadById(id: string) {
    return this.http.get(constants.IAPI_ENDPOINT + `/communication/email/thread/${id}`, this.httpOptionsAuth);
  }

  createNewEmail(emailData: postEmailData) {
    return this.http.post(constants.IAPI_ENDPOINT + '/communication/email', JSON.stringify(emailData), this.httpOptionsAuth);
  }

  replyToExistingEmail(parentEmailId: string, emailData: postEmailData) {
    return this.http.post(constants.IAPI_ENDPOINT + `/communication/email/${parentEmailId}`, JSON.stringify(emailData), this.httpOptionsAuth);
  }

  commentOnEmail(claimId: string, commentData: postCommentData) {
    return this.http.post(constants.IAPI_ENDPOINT + `/communication/comment/${claimId}`, JSON.stringify(commentData), this.httpOptionsAuth);
  }

  getComments(claimId: string) {
    return this.http.get(constants.IAPI_ENDPOINT + `/communication/claim/${claimId}/comments`, this.httpOptionsAuth);
  }

  deleteComment(id: string) {
    return this.http.delete(constants.IAPI_ENDPOINT + `/communication/comment/${id}`, this.httpOptionsAuth);
  }
}
